/**
 * FAQ Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the FAQ template.
 *
 * @namespace faq
 */

import loaded from '@/scripts/utils/loaded';
import {$$, offsetTop, scrollToY} from '@/scripts/utils/dom';
import Accordion from '@/scripts/components/Accordion';


const selectors = {
  details: {
    container: '.faq__details.accordion',
    trigger: '.faq__details__trigger.accordion',
    content: '.faq__details__content.accordion',
    contentInternal: '.faq__details__answer.accordion',
    subsectionContent: '.faq__questions > *',
  },
  overlay: {
    overlayEl: '.signup',
    trigger: '.signup__overlay__trigger'
  },
  mobileNavSelectors: {
    mobileSelector: '.faq__nav__mobile__tab li',
    mobileContainer: '.faq__questions > div'
  },
  stickyNavSelectors: {
    stickyNavItem:  'a[class*="subsection-navitem"]'
  }
};

const hiddenClass = 'hidden';
const currentClass = 'current';

class FAQ {

  faqAccordion = () => {
    const {container, content, contentInternal, trigger} = selectors.details;
    const details = document.querySelectorAll(container);

    if (details) {
      details.forEach(element => {
        new Accordion(element, trigger, content, contentInternal); // eslint-disable-line curly
      });
    }
  };

  faqOverlay = () => {
    const {overlayEl, trigger} = selectors.overlay;
    const overlay = document.querySelector(overlayEl);

    if (overlay) {
      new Overlay(overlayEl, trigger); // eslint-disable-line curly
    }
  };

  faqMobileNav = () => {
    const mobileSelectors = $$(selectors.mobileNavSelectors.mobileSelector);
    const mobileContainers = $$(selectors.mobileNavSelectors.mobileContainer);
    if ((mobileSelectors.length === 0) || (mobileContainers.length === 0)) {
      return;
    }
    mobileSelectors.forEach((mobileSelector) => {
      mobileSelector.addEventListener('click', function(event) {
        mobileSelectors.forEach((element) => element.classList.remove(currentClass));
        mobileContainers.forEach((element) => element.classList.add(hiddenClass));
        let selector = event.target.getAttribute('class');
        selector = selector.replace('trigger', 'content');
        $$('.' + selector).forEach((element) => element.classList.remove(hiddenClass));
        event.target.classList.add(currentClass);
      });
    });
  };

  faqStickyNav = () => {
    const stickyNavItems = $$(selectors.stickyNavSelectors.stickyNavItem);
    if ((stickyNavItems.length === 0)) {
      return;
    }
    stickyNavItems[0].classList.add('selected');
    stickyNavItems.forEach((stickyNavItem) => {
      stickyNavItem.addEventListener('click', function(event) {
        stickyNavItems.forEach((element) => element.classList.remove('selected'));
        let selectorAnchor = event.target.closest('a');
        if (!selectorAnchor) {
          return;
        }
        selectorAnchor.classList.add('selected');
        let selector = selectorAnchor.dataset.navitem;
        selector = selector.replace('navitem', 'content');
        const target = document.querySelector('.' + selector);
        if (target) {
          scrollToY(offsetTop(target) - 10);
        }
      });
    });

  };

  constructor() {
    this.faqAccordion();
    this.faqOverlay();
    this.faqMobileNav();
    this.faqStickyNav();
  }
}

loaded(() => new FAQ());
